"use client";

import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function VisualAnthology() {
  const projects = [{
    name: "Runway Sequence 01",
    location: "Paris Fashion Week",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_01.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_01.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_01.png-wvc-sizes",
    aspect: "aspect-[4/5]"
  }, {
    name: "Fabric Draping Study",
    location: "Atelier Archive",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_draping_study.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_draping_study.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_draping_study.webp-wvc-sizes",
    aspect: "aspect-[3/2]"
  }, {
    name: "Technical Blueprint",
    location: "Pattern Engineering",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_blueprint_sketch.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_blueprint_sketch.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_blueprint_sketch.png-wvc-sizes",
    aspect: "aspect-square"
  }, {
    name: "Runway Sequence 02",
    location: "Paris Fashion Week",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_02.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_02.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_02.png-wvc-sizes",
    aspect: "aspect-[4/5]"
  }, {
    name: "Textile Texture Detail",
    location: "Sustainable Sourcing",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_textile_detail.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_textile_detail.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_textile_detail.webp-wvc-sizes",
    aspect: "aspect-[3/2]"
  }, {
    name: "Garment Construction",
    location: "Atelier Process",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_construction_detail.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_construction_detail.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_construction_detail.webp-wvc-sizes",
    aspect: "aspect-square"
  }, {
    name: "Runway Sequence 03",
    location: "Paris Fashion Week",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_03.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_03.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_03.png-wvc-sizes",
    aspect: "aspect-[4/5]"
  }, {
    name: "Pattern Making Draft",
    location: "Technical Archive",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_pattern_draft.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_pattern_draft.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_pattern_draft.png-wvc-sizes",
    aspect: "aspect-[3/2]"
  }, {
    name: "Studio Thorne Detail",
    location: "Brand Identity",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_brand_detail.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_brand_detail.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_brand_detail.png-wvc-sizes",
    aspect: "aspect-square"
  }, {
    name: "Runway Sequence 04",
    location: "Paris Fashion Week",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_04.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_04.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_runway_04.png-wvc-sizes",
    aspect: "aspect-[4/5]"
  }, {
    name: "Sustainable Fiber Study",
    location: "Material Research",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_fiber_study.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_fiber_study.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_fiber_study.png-wvc-sizes",
    aspect: "aspect-[3/2]"
  }, {
    name: "Final Fitting Session",
    location: "Atelier Floor",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_fitting_session.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_fitting_session.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/thorne_fitting_session.webp-wvc-sizes",
    aspect: "aspect-square"
  }];
  return <section data-section-id="2842" id="visual-anthology" className="bg-background text-foreground pt-32 pb-24">
      {}
      <div className="max-w-4xl mx-auto px-6 text-center mb-20">
        
        <h2 className="font-default font-light text-5xl md:text-7xl leading-[1.05] tracking-tight text-foreground">
          Technical Couture,{" "}
          <em className="italic font-normal" style={{
          color: "var(--primary)"
        }}>
            Engineered.
          </em>
        </h2>
        <p className="font-default text-base md:text-lg text-muted-foreground mt-8 max-w-2xl mx-auto leading-relaxed">
          A curated archive of Studio Thorne, where sustainable textile innovation meets clinical garment construction.
        </p>
      </div>

      {}
      <div className="w-full px-1">
        <div className="columns-2 md:columns-3 lg:columns-4 gap-1 space-y-1">
          {projects.map((project, i) => <div data-index={i} key={i} className="group relative overflow-hidden break-inside-avoid mb-1">
              <div className={`relative ${project.aspect} overflow-hidden`}>
                <img src={project.src} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={`${project.name} — ${project.location}`} loading="lazy" decoding="async" className="w-full h-full object-cover transition-all duration-700 ease-out group-hover:scale-[1.02] saturate-100 group-hover:saturate-[0.7]" />

                {}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
              background: "linear-gradient(to top, hsla(25, 25%, 12%, 0.85) 0%, hsla(25, 25%, 12%, 0) 60%)"
            }} />

                {}
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 ease-out">
                  <h3 className="font-default text-xl md:text-2xl font-light text-white leading-tight">
                    {project.name}
                  </h3>
                  <p className="font-default text-[10px] md:text-xs tracking-[0.2em] uppercase mt-2 text-gray-300">
                    {project.location}
                  </p>
                </div>

                {}
                <Link to="/CollectionsPage" className="absolute bottom-4 right-4 md:bottom-5 md:right-5 inline-flex items-center gap-1.5 font-default text-[10px] md:text-xs tracking-[0.25em] uppercase transition-colors duration-300 hover:opacity-80" style={{
              color: "var(--ring)"
            }} aria-label={`View project: ${project.name}`}>
                  <span>View Archive</span>
                  <ArrowUpRight className="size-3 md:size-3.5" strokeWidth={1.5} />
                </Link>
              </div>
            </div>)}
        </div>
      </div>

      {}
      <div className="flex justify-center mt-20 px-6">
        <Button asChild variant="outline" size="lg" className="font-default text-xs tracking-[0.25em] uppercase h-14 px-10 bg-transparent border-foreground/30 text-foreground hover:bg-foreground/5 hover:border-foreground/60 hover:text-foreground rounded-md">
          <Link to="/CollectionsPage">
            <span>Download Line Sheet</span>
            <ArrowRight className="size-4 ml-1" strokeWidth={1.5} />
          </Link>
        </Button>
      </div>
    </section>;
}